import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Card from '../components/ui/Card';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';
import FastAPIClient from '../services/apiClient';
import logo_1024_X_1024 from '../assets/logo_1024_X_1024.png';

const VerificationCodePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const client = new FastAPIClient();
    const users_id = location.state?.users_id || null;

    const [formData, setFormData] = useState({ code: '' });
    const [errors, setErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState('idle');
    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
        }
    };

    const validateForm = () => {
        let newErrors = {};
        if (!formData.code) {
            newErrors.code = 'Verification code is required.';
        } else if (!/^\d{6}$/.test(formData.code)) {
            newErrors.code = 'Code must be a 6-digit number.';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitStatus('loading');
        setErrors({});
        setSuccessMessage('');

        if (!validateForm()) {
            setSubmitStatus('error');
            setErrors((prev) => ({ ...prev, general: 'Please correct the errors in the form.' }));
            return;
        }

        try {
            // console.log({users_id: users_id,code:formData.code})
            const response = await client.verifyCode(users_id, formData.code);
            // console.log(response)
            setSubmitStatus('success');
            setSuccessMessage('Verification successful! Redirecting to dashboard...');
            setTimeout(() => {
                navigate('/dashboard');
            }, 1500);
        } catch (error) {
            console.error('Verification error:', error);
            setSubmitStatus('error');
            const errorMessage = error.response?.data?.detail || error.response?.data?.message || error.message || 'An unexpected error occurred during verification.';
            setErrors((prev) => ({ ...prev, general: errorMessage }));
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-light p-4">
            <Card className="w-full max-w-md mx-auto p-8">
                <div className="flex justify-center mb-6">
                    <img
                        src={logo_1024_X_1024}
                        alt="Arxis Logo"
                        className="w-24 h-24 object-contain rounded-lg select-none pointer-events-none"
                        onContextMenu={(e) => e.preventDefault()}
                        draggable="false"
                    />
                </div>

                <h2 className="text-2xl font-bold text-center text-text-primary mb-6">
                    Confirm Your Identity
                </h2>
                <p className="text-center text-text-secondary mb-6 text-sm">
                    Enter the 6-digit code sent to {location.state.logon_id || 'your email'}.
                </p>

                <form onSubmit={handleSubmit} noValidate>
                    <Input
                        label="Verification Code"
                        id="code"
                        name="code"
                        type="text"
                        placeholder="e.g., 123456"
                        value={formData.code}
                        onChange={handleChange}
                        required
                        error={errors.code}
                    />
                    {errors.code && <p className="text-gmail-red text-xs mt-[-10px] mb-4">{errors.code}</p>}

                    {submitStatus === 'error' && errors.general && (
                        <p className="text-gmail-red text-sm text-center mb-4">{errors.general}</p>
                    )}
                    {submitStatus === 'success' && successMessage && (
                        <p className="text-gmail-green text-sm text-center mb-4">{successMessage}</p>
                    )}

                    <Button
                        type="submit"
                        fullWidth
                        disabled={submitStatus === 'loading'}
                        className="mt-4"
                    >
                        {submitStatus === 'loading' ? 'Verifying...' : 'Verify'}
                    </Button>
                </form>
                <p className="text-center text-sm text-text-secondary mt-6">
                    Retry Log In?{' '}
                    <Link to="/login" className="text-gmail-blue hover:underline focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-gmail-blue rounded-sm">
                        Retry Login
                    </Link>
                </p>
            </Card>
        </div>
    );
};

export default VerificationCodePage;